import { Component } from '@angular/core';
import { CompareFirstUseSlidesService } from '../first-use-slides.service';

@Component({
  selector: 'app-cp-compare-fus-data',
  templateUrl: './cp-compare-fus-data.component.html',
  styleUrls: ['./cp-compare-fus-data.component.scss']
})
export class CpCompareFUSDataComponent {

  constructor(
    private firstUseSlidesService: CompareFirstUseSlidesService,
  ) {}

  close() {
    this.firstUseSlidesService.registerCloseFirstUseSlides();
  }

}
